import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderSelectionList from "./ForwarderSelectionList";
import { StyledSection, StyledTitle } from "../StyledWizardComponents";
const SelectForwarder = ({ forwarders = void 0, onForwarderSelect, onStartForwarderClick }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const sendTelemetry = useSendTelemetry("forwarder-create");
  const handleForwarderSelection = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_CONFIGURE_FORWARDER_SELECTED, {
      app_pathname: "forwarder"
    });
    onForwarderSelect();
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, t("select_forwarder.heading")), /* @__PURE__ */ React.createElement(StyledSection, null, /* @__PURE__ */ React.createElement("p", null, t("select_forwarder.start_hint")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onStartForwarderClick }, t("select_forwarder.start_button"))), /* @__PURE__ */ React.createElement(StyledSection, null, /* @__PURE__ */ React.createElement("p", null, t("select_forwarder.select_list")), /* @__PURE__ */ React.createElement(ForwarderSelectionList, { forwarders, onForwarderSelect: handleForwarderSelection }))));
};
export default SelectForwarder;
